import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import IssuanceTypeForm from '../../../components/issuance-type-form';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Notify from "../../../components/notify";
import { createIssuanceTypeAPI, getAllDepartmentsAPI } from '../../../services/api';
import './CreateNewDepartment.scss';

const CreateNewIssuanceType = () => {
  const [departments, setDepartments] = useState([]);
  const [openNotification, setOpenNotification] = useState(false);
  const [errors, setErrors]                     = useState({});
  const [loading, setLoading]                   = useState(false);
  const history = useHistory();

  useEffect(() => {
    getDepartments();
  }, []);

  const getDepartments = async () => {
    try {
      const departments = await getAllDepartmentsAPI();
      setDepartments(departments);
    } catch (err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Getting All Departments Failed !!' };
      setErrors(errors);
      setOpenNotification(true);
      setLoading(false);
    }
  };

  const handleSubmit = async (payload) => {
    try {
      setLoading(true);
      const response = await createIssuanceTypeAPI(payload);
      setErrors({});
      setOpenNotification(true);
      setTimeout(() => {
        setLoading(false);
        redirectToIssuanceList();
      }, 1000);
    } catch(err) {
      const errors =
        err && Object.keys(err).length > 0
          ? err
          : { errormessage: 'Department Creation Failed !!!!' };
      setErrors(errors);
      setOpenNotification(true);
      setLoading(false);
    }
  }

  const redirectToIssuanceList = () => {
    history.push('/issuance-type/list');
  };

  return (
    <>
      <Navbar />
      <div className="min-h-full flex justify-center items-center bg-black text-white container">
        <div className="create-user container">
          <div className="flex flex-col text-center heading">
            <h2>Create Issuance Type</h2>
          </div>
          <IssuanceTypeForm
            departments={departments}
            issuanceType={{}}
            handleSubmit={handleSubmit}
            redirectToIssuanceList={redirectToIssuanceList}
            loading={loading}
          />
          <Notify
            open={openNotification}
            onClose={() => setOpenNotification(false)}
            successMessage={"Issuance Type successfully created!"}
            errors={errors}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CreateNewIssuanceType;